import { Inject, Injectable } from '@angular/core';
import { LibConfig, LibConfigService } from '../config.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class EquipmentReportService {

  constructor(
    @Inject(LibConfigService) protected config: LibConfig,
    protected http: HttpClient
  ) { }

}
